import { eIThoiKhoaBieuViewActionTypeIds } from './../../action-types/thoi-khoa-bieu/IThoiKhoaBieuViewActionType';
import { baseAction } from "../IActionBase";
import { IThoiKhoaBieuItemSelectRequest } from '../../../models/request/thoi-khoa-bieu/IThoiKhoaBieuItemSelectRequest';
import { pl_tkb_chitiet_view } from '../../../models/response/thoi-khoa-bieu/pl_tkb_chitiet';

export const thoiKhoaBieuViewAction = {
    changeViewMode: (mode: "lop" | "phong_hoc" | "giao_vien") => baseAction(eIThoiKhoaBieuViewActionTypeIds.CHANGE_VIEW_MODE, mode),
    changeRequest: (rq: IThoiKhoaBieuItemSelectRequest) => baseAction(eIThoiKhoaBieuViewActionTypeIds.CHANGE_REQUEST, rq),
    loadStart: (rq: IThoiKhoaBieuItemSelectRequest) => baseAction(eIThoiKhoaBieuViewActionTypeIds.LOAD_START, rq),
    loadSuccess: (data: pl_tkb_chitiet_view[]) => baseAction(eIThoiKhoaBieuViewActionTypeIds.LOAD_SUCCESS, data.map(x => ({
        ...x,
        arr_dm_lop_ids: x.dm_lop_ids?.split(',').map(x=> parseInt(x)) ?? []
    }))),
    loadError: (m: string) => baseAction(eIThoiKhoaBieuViewActionTypeIds.LOAD_ERROR, m),
}